/**
 * The patient file form's state, from a saved file.
 *
 * The server stores an empty national ID, phone or insurance code as NULL, and
 * the form used to copy those NULLs over its blank strings. Its first render
 * then called `.trim()` on one of them, and opening "بيانات المريض" for an
 * existing patient crashed the whole desk with "Cannot read properties of
 * null (reading 'trim')". Every text field is a string here, whatever the
 * row holds.
 *
 * Pure: no React.
 */

export const blankPatientForm = () => ({
  fullName: '',
  nationalId: '',
  phonePrimary: '',
  phoneSecondary: '',
  insuranceCode: '',
  dateOfBirth: '',
  gender: '',
  chronicDiseases: [],
  currentMedications: [],
  complaints: '',
  medicalHistory: '',
  patientType: 'cash',
  insuranceProvider: '',
  contractPartyId: '',
  employerName: '',
  insuranceExpiry: '',
});

const text = (value) => (value === null || value === undefined ? '' : String(value));

const medication = (m) => ({
  ...(m && typeof m === 'object' ? m : {}),
  name: text(m?.name),
  concentration: text(m?.concentration),
  frequency: text(m?.frequency),
  duration: text(m?.duration),
});

export function patientFormFrom(patient) {
  const form = blankPatientForm();
  const p = patient && typeof patient === 'object' ? patient : {};
  for (const key of Object.keys(form)) {
    if (Array.isArray(form[key])) continue;
    if (p[key] === null || p[key] === undefined) continue;
    form[key] = text(p[key]);
  }
  form.patientType = form.patientType || 'cash';
  form.chronicDiseases = Array.isArray(p.chronicDiseases) ? p.chronicDiseases.map(text).filter(Boolean) : [];
  form.currentMedications = Array.isArray(p.currentMedications) ? p.currentMedications.map(medication) : [];
  form.contractPartyId = p.contractPartyId ? String(p.contractPartyId) : '';
  return form;
}

/** True when the form carries at least one way to find the patient again. */
export const hasPatientIdentifier = (form) =>
  ['nationalId', 'phonePrimary', 'phoneSecondary', 'insuranceCode'].some((key) => text(form?.[key]).trim() !== '');
